import { useTranslation } from 'react-i18next';

import * as graphql from '@treams/treams-network';
import { Button } from '@treams/treams-ui/common/button/Button';

const DOWNLOAD_REVOKE_DELAY_MS = 1000;

function downloadCertificate(certificate: string) {
	const blob = new Blob([certificate], { type: 'application/x-pem-file' });

	const url = URL.createObjectURL(blob);
	const anchor = document.createElement('a');
	anchor.href = url;
	anchor.download = 'certificate.pem';
	document.body.appendChild(anchor);
	anchor.click();
	anchor.remove();

	setTimeout(() => URL.revokeObjectURL(url), DOWNLOAD_REVOKE_DELAY_MS);
}

export default function ConfigurationFieldCertificate(props: {
	field: graphql.ConnectorConfigFieldCertificate;
	onChange: (input: Partial<graphql.UpdateConnectorConfigFieldInput>) => Promise<void>;
}) {
	const { t } = useTranslation();

	const { certificate } = props.field;

	if (certificate) {
		return (
			<Button
				small
				type="secondary"
				title={t('connectors.settings.configuration.certificate.download')}
				onClick={() => downloadCertificate(certificate)}
			/>
		);
	}

	return (
		<Button
			small
			type="primary"
			title={t('connectors.settings.configuration.certificate.create')}
			onClick={() => props.onChange({})}
		/>
	);
}
